import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 40px 24px 20px;
`;

export const CheckboxContainer = styled.div`
  padding-top: 20px;
`;

export const RadioLabel = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
`;

export const ButtonContainer = styled.div`
  padding-top: 40px;
`;
